var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lobby-premeeting-screen" },
    [
      _c("LobbyJoinModal", {
        attrs: { "is-response-waiting": _vm.isResponseWaiting },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }